import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { usePostAddRoommatesToBasket } from 'src/lib/hooks/use-post-add-roommates-to-basket';
import { RoommateFormValues } from 'src/features/multi-occupancy/constants';
import { routes } from 'src/constants/routes';
import { ApiBasket } from 'src/api/basketService/types';

import { RoommatesView } from './roommates.view';

export const RoommatesContainer: FC<{ basket: ApiBasket; numberOfStudents: number }> = ({
    basket,
    numberOfStudents,
}) => {
    const navigate = useNavigate();
    const { mutateAsync: addRoommatesToBasket, isPending } = usePostAddRoommatesToBasket();

    const handleGoBack = () => {
        navigate(routes.yourDetails.index);
    };

    const handleSubmit = async (values: RoommateFormValues) => {
        await addRoommatesToBasket({
            basketId: basket.id,
            roommates: values.roommates,
            updatedAt: basket.updated_date,
        });

        navigate(routes.agreements.index);
    };

    return (
        <RoommatesView
            onGoBack={handleGoBack}
            onSubmit={handleSubmit}
            isPending={isPending}
            basket={basket}
            numberOfStudents={numberOfStudents}
        />
    );
};
